var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ring-product-description-price"},[_c('span',[_vm._v(_vm._s(_vm.$t("Price")))]),_c('p',[_vm._v(" "+_vm._s(_vm.priceFormatted)+" USDT")])])
}
var staticRenderFns = []

export { render, staticRenderFns }